import { FF_CLEAR_FEATURE_FLAGS, FF_SET_FEATURE_FLAGS, FF_SET_FEATURE_FLAG_PAYLOAD } from '../actions/actionTypes';
import initialState from './initialState';

export default function featureFlagsReducer(state = initialState.featureFlags, action) {
  const { type, payload } = action;
  switch (type) {
    case FF_SET_FEATURE_FLAGS:
      return {
        ...state,
        flags: {
          ...state.flags,
          ...payload.flags,
        },
        isLoaded: true,
      };
    case FF_SET_FEATURE_FLAG_PAYLOAD:
      return {
        ...state,
        payloads: {
          ...state.payloads,
          [payload.flagName]: payload.payload,
        },
      };
    case FF_CLEAR_FEATURE_FLAGS:
      return {
        ...state,
        flags: {},
        payloads: {},
        isLoaded: false,
      };
    default:
      return state;
  }
}
